<template>
  <section class="form-data">
    <!-- Header -->
    <div class="header">PRODUCT SALES</div>

    <!-- Graph -->
    <div class="graph-wrapper" v-if="completeRevenue !== 0">
      <div class="graph">
        <div style="margin-bottom: 15px; display: flex">Revenue</div>
        <LineChart
          :chartData="chartData"
          :options="chartOptions"
          :height="250"
        />
      </div>
      <div style="position: relative; bottom: -225px; right: 15px">Date</div>

      <div class="completeRevenue" style="position: relative">
        <statistics-title
          style="width: 250px"
          titleText="TOTAL REVENUE"
        ></statistics-title>
        <div style="font-size: 30px; margin-bottom: 30px">
          {{ completeRevenue }} {{ $currency == "kr." ? "DKK" : $currency }}
        </div>
      </div>
    </div>
    <div class="error-no-sales" v-else>
      <h2>You do not have any product sales to display yet</h2>
      <p>Create a product box and wait for guests to order!</p>
    </div>

    <!-- List -->
    <div class="list" v-for="(form, index) in forms" :key="form.formID">
      <div class="list-item" @click="displayItems(form)">
        <div class="row__item">
          <div class="column">
            <div class="list-item__visibility">
              <div
                class="visibility__precheckin"
                v-if="form.visibility.includes('precheckin')"
              >
                PRECHECKIN
              </div>
              <div
                class="visibility__checkin"
                v-if="form.visibility.includes('checkin')"
              >
                CHECKIN
              </div>
              <div
                class="visibility__fromqr"
                v-if="form.visibility.includes('anonymous')"
              >
                FROM QR
              </div>
              <div
                class="visibility__hidden"
                v-if="form.visibility.length == 0"
              >
                HIDDEN
              </div>
              <div
                class="visibility__deleted"
                v-if="form.visibility == 'deleted'"
              >
                DELETED
              </div>
            </div>
            <div class="list-item__title">
              {{ form.formTitle.toUpperCase() }}
            </div>
            <div class="list-item__date">
              Created at {{ timeConverter(form.created) }}
              <span
                class="list-item__remove"
                v-if="form.visibility == 'deleted'"
                @click="deleteItem(form.formID)"
                >Delete from statistics</span
              >
            </div>
          </div>
          <div class="column__revenue">
            <div class="list-item__revenue-label">GENERATED REVENUE</div>
            <div class="list-item__revenue-value">
              <span style="color: #2cb978">{{
                convertNumber(form.totalRevenue)
              }}</span>
              {{ $currency == "kr." ? "DKK" : $currency }}
            </div>
            <v-icon
              name="chevron-up"
              class="dropdown"
              scale="2"
              v-if="activeIndexArray.includes(form)"
            ></v-icon>
            <v-icon
              name="chevron-down"
              class="dropdown"
              scale="2"
              v-else
            ></v-icon>
          </div>
        </div>
        <div class="row__item-details" v-if="activeIndexArray.includes(form)">
          <div class="row__items-zero" v-if="form.items.length === 0">
            No items has been sold yet
          </div>
          <div
            class="row__items-list"
            v-else
            :items="form.items"
            :index="index"
          >
            <div class="row__items">
              <div v-for="item in form.items" :key="item.id">
                <div class="item">
                  <div class="item__title">{{ item.title }}</div>
                  <div class="item__count">
                    AMOUNT:
                    <span style="color: #2cb978">{{
                      item.amount ? item.amount : "-"
                    }}</span>
                  </div>
                  <div class="item__revenue">
                    REVENUE :
                    <span style="color: #2cb978"
                      >{{
                        (item.amount ? item.amount : "-") * item.price
                      }} </span
                    >{{ $currency == "kr." ? "DKK" : $currency }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- FormItem.vue has been merged with FormData.vue. FormItem Functionality commented out for now -->
          <!--FormItem  v-else :items='form.items' :index='index' /-->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
//import FormItem from './FormItem'
import LineChart from "../LineChart";
import StatisticsTitle from "../StatisticsTitle";
import { firestore } from "@/firebase";

export default {
  components: {
    //FormItem,
    LineChart,
    StatisticsTitle,
  },
  props: {
    forms: Array,
    items: Array,
  },
  data() {
    return {
      showItems: false,
      formIndex: -1,
      indexArray: [],
      activeIndexArray: [],
      chartData: {},
      chartOptions: {
        legend: {
          display: false,
        },
        tooltips: {
          intersect: false,
          displayColors: false,
          xPadding: 25,
          yPadding: 8,
          titleFontSize: 16,
          bodyFontSize: 20,
          bodyAlign: "center",
          titleAlign: "center",
          backgroundColor: "#48b9ba",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
      chartLabels: [],
      dataPoints: [],
    };
  },
  mounted() {
    this.handleMonth();
    this.populateData();
  },
  computed: {
    completeRevenue() {
      let totalValue = [];
      for (let i = 0; i < this.forms.length; i++) {
        totalValue.push(this.forms[i].totalRevenue);
      }

      return totalValue.reduce((a, b) => a + b, 0);
    },
  },
  methods: {
    deleteItem(formID) {
      firestore
        .collection("FormStatistics")
        .doc(this.$hotelId)
        .collection("Forms")
        .doc(formID)
        .delete();
      this.$emit("updatedFormList");
    },
    displayItems(form) {
      // console.log(JSON.stringify(this.forms));
      if (!this.activeIndexArray.includes(form)) {
        this.activeIndexArray.push(form);
        //console.log(this.activeIndexArray.length);
      } else {
        this.activeIndexArray = this.activeIndexArray.filter(
          (item) => item !== form
        );
      }
    },
    convertNumber(someValue) {
      return someValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    timeConverter(UNIX_timestamp) {
      const a = new Date(UNIX_timestamp);
      const date = a.getDate();
      const year = a.getFullYear();
      const month = a.getMonth() + 1; // The month counting starts from 0
      const time = date + "/" + month + "/" + year;
      return time;
    },
    populateData() {
      this.chartData = {
        labels: this.chartLabels,
        datasets: [
          {
            label: "+ " + (this.$currency == "kr." ? "DKK" : this.$currency),
            data: this.dataPoints,
            fill: false,
            borderColor: "#48b9ba",
            borderWidth: 5,
          },
        ],
        responsive: true,
        maintainAspectRatio: true,
      };
    },
    handleMonth() {
      let acumulatedMoney = new Map();

      // two dimentional array, each inner array holds a period of time, finally concat them to make a single array
      for (let i = 0; i <= this.forms.length - 1; i++) {
        if (this.forms[i].orders) {
          for (let j = 0; j <= this.forms[i].orders.length - 1; j++) {
            for (
              let k = 0;
              k <= this.forms[i].orders[j].items.length - 1;
              k++
            ) {
              //TODO wrote Sunday morning for quick fix, explanation - always adding traling zeros and then slicing to get only two characters.
              let dateOfOrder =
                ("0" + new Date(this.forms[i].orders[j].date).getDate()).slice(
                  -2
                ) +
                "/" +
                (
                  "0" +
                  (new Date(this.forms[i].orders[j].date).getMonth() + 1)
                ).slice(-2) +
                "/" +
                new Date(this.forms[i].orders[j].date).getFullYear();

              let temp = acumulatedMoney.get(dateOfOrder)
                ? acumulatedMoney.get(dateOfOrder)
                : 0;
              acumulatedMoney.set(
                dateOfOrder,
                (temp += this.forms[i].orders[j].items[k].price)
              );
            }
          }
        }
      }

      let sortedMoney = new Map(
        [...acumulatedMoney.entries()].sort(function (a, b) {
          var aa = a[0].split("/").reverse().join(),
            bb = b[0].split("/").reverse().join();

          return aa < bb ? -1 : aa > bb ? 1 : 0;
        })
      );

      this.chartLabels = Array.from(sortedMoney.keys());
      this.dataPoints = Array.from(sortedMoney.values());
    },
    adjustDate(date) {
      date = date.split("-").reverse();
      return `${date[2].replace(/^0/, "")}/${date[1].replace(/^0/, "")}`;
    },
  },
};
</script>

<style scoped>
/*
    Header
  */

.header {
  display: flex;
  margin: 40px 0 40px;
  font-weight: 500;
  font-size: 36px;
}

/*
    Graph
  */
.graph-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.graph {
  width: 50%;
  height: 100%;
}
.completeRevenue {
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: 0 3px 4px #adadad;
  border-radius: 3px;
  padding: 10px 30px;
  margin-left: 100px;
}

.error-no-sales {
  padding-bottom: 16px;
}

/*
    List
  */

.row__item {
  height: 200px;
  background-color: #fff;
  padding: 0px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.row__item-details {
  background-color: #fff;
  padding: 0px 20px 20px;
  border-radius: 0px 0px 8px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.row__items-zero {
  padding: 20px;
  width: 100%;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-content: center;
}

.row__items {
  background: #eeeeee;
  width: 100%;
  height: 100%;
  padding-top: 20px;
}

.row__items-list {
  width: 100%;
  height: 100%;
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin: 0px 20px 20px;
}

.item__title,
.item__count,
.item__revenue {
  flex: 1;
}

.item__title {
  text-align: left;
}

.item__revenue {
  text-align: right;
}

.row__items-list {
  color: black;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.column {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
}

.column__revenue {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.list-item {
  margin-bottom: 40px;
  border-radius: 8px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
}

.list-item__title {
  font-size: 30px;
}

.list-item__revenue-label,
.list-item__revenue-value {
  font-size: 35px;
  padding: 10px;
  min-width: 300px;
}

.list-item__remove {
  color: #eb5757;
  border: solid 1px;
  padding: 4px;
  font-weight: 900;
}

/*
    Visibility
  */

.list-item__visibility {
  display: flex;
  font-size: 15px;
}

.visibility__precheckin {
  color: #fff;
  background: #2cb978;
  border-radius: 8px;
  padding: 5px 15px;
  margin-right: 20px;
}

.visibility__checkin {
  color: #fff;
  background: #0c627e;
  border-radius: 8px;
  padding: 5px 15px;
  margin-right: 20px;
}

.visibility__fromqr {
  color: #fff;
  background: #894e99;
  border-radius: 8px;
  padding: 5px 15px;
}

.visibility__deleted {
  color: #fff;
  background: #707070;
  border-radius: 8px;
  padding: 5px 15px;
}

.visibility__hidden {
  color: #fff;
  background: #894e99;
  border-radius: 8px;
  padding: 5px 15px;
}

.dropdown {
  position: relative;
  width: 30px;
  left: 330px;
}
</style>
